import { Plugins } from '@leverege/plugin';
export const DataSourceFactory = Plugins.createFactory('DataSource', {
  pluginKey: 'dataSource',
  strategy: Plugins.LOOKUP
});

/**
 * This will lookup the data for the object ref from the installed
 * DataSource. The objRef should be at minimum a object (or array of objects)
 * containing { type, id, ref } .
 * @param {ObjectRef or array of ObjectRef} objRef the data object(s) to return data for 
 * @returns Returns null, the data or an array of data object/null
 */
function getData(objRef) {
  if (Array.isArray(objRef)) {
    const r = [];
    for (let n = 0; n < objRef.length; n++) {
      r.push(getData(objRef[n]));
    }
    return r;
  }
  const src = DataSourceFactory.get(objRef.type);
  if (src) {
    return src.getData(objRef) || objRef?.data || null;
  }
  return null;
}

/**
 * This will lookup the delegate object for the object ref from the installed
 * DataSource. The objRef should be at minimum a object (or array of objects)
 * containing { type, id, ref } .
 * @param {ObjectRef or array of ObjectRef} objRef the data object(s) to return delegate for 
 * @returns Returns null, the delegate object or an array of delegate object/null
 */
function getDelegate(objRef) {
  if (Array.isArray(objRef)) {
    const r = [];
    for (let n = 0; n < objRef.length; n++) {
      r.push(getDelegate(objRef[n]));
    }
    return r;
  }
  const src = DataSourceFactory.get(objRef.type);
  if (src && src.getDelegate) {
    return src.getDelegate(objRef);
  }

  // TODO: Remove this once backwards compatibility is no longer needed
  if (src && src.getActions) {
    return src.getActions(objRef);
  }
  return null;
}

/**
 * This will return an array or object that contains the data as well as the
 * id, ref, and type fields.
 * @param {ObjectRef or array of ObjectRef} objRef the data object(s) to return delegate for 
 * @returns Returns null, the delegate object or an array of delegate object/null
 */
function withData(objRef) {
  if (objRef == null) {
    return null;
  }
  if (Array.isArray(objRef)) {
    const r = [];
    for (let n = 0; n < objRef.length; n++) {
      const src = DataSourceFactory.get(objRef[n].type);
      const data = src?.getData(objRef[n]) || objRef[n].data || null;
      r.push({
        ...objRef[n],
        data
      });
    }
    return r;
  }
  const src = DataSourceFactory.get(objRef.type);
  const data = src?.getData(objRef) || objRef.data || null;
  return {
    ...objRef,
    data
  };
}
function get(objectType) {
  return DataSourceFactory.get(objectType);
}
export default {
  getData,
  getDelegate,
  getActions: getDelegate,
  withData,
  get
};